module.exports = __webpack_public_path__ + "static/dreams_of_paradise.bc75ba4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/dreams_of_paradise.jpg
// module id = 495
// module chunks = 35783957827783